import { Link as RouterLink } from "react-router-dom"

import { L2RButton, Typography, styledForMobile, styled } from "@l2r-front/l2r-ui"

import { AppBar as AppBarComponent } from "../../components/AppBar"
import { NetworkSelector as L2rNetworkSelector } from "../../containers/NetworkSelector"

export const ErrorPageWrapper = styledForMobile("div", ["background"])(({ background, isMobile }) => ({
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: isMobile ? "column" : "row-reverse",
    height: "100%",
    width: "100%",
}))

export const Message = styledForMobile(Typography)(({ isMobile, theme }) => ({
    color: theme.palette["gray/0"].main,
    fontSize: "bold",
    textAlign: isMobile && "left",
    whiteSpace: isMobile && "pre-line",
    width: "100%",
}))

export const MessageWrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(7),
    marginRight: !isMobile && "20%",
    padding: theme.spacing(isMobile ? 6 : 0),
    height: "100%",
    justifyContent: isMobile ? "space-between" : "center",
    textAlign: "center",
    width: isMobile ? "100%" : 500,

    "@media(max-width: 1200px)": {
        marginRight: "15%",
    },
}))

export const Button = styledForMobile(L2RButton)(({ isMobile }) => ({
    width: isMobile ? "100%" : "fit-content",
}))

export const AppBar = styled(AppBarComponent)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 2,
}))

export const Link = styled(RouterLink)({
    alignItems: "center",
    display: "flex",
    height: "100%",
})

export const NetworkSelector = styled(L2rNetworkSelector)({
    marginLeft: "auto",
})

export const Logo = styled("img")(() => ({
    height: 36,
}))

export const SmallLogo = styled("img")(() => ({
    height: 30,
}))
